import React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const UnsaveDiscount = ({ openUnsaveState, setConfirmUnsave }) => {
  const classes = useStyles();
  const [openUnsave, setOpenUnsave] = openUnsaveState;

  const onClose = () => setOpenUnsave(false);

  const onConfirm = () => {
    setConfirmUnsave(true);
    onClose();
  };

  return (
    <Dialog
      disableBackdropClick
      fullWidth
      maxWidth="xs"
      open={openUnsave}
      onClose={onClose}
    >
      <DialogTitle> Unsave Discount </DialogTitle>
      <DialogContent dividers>
        <Typography>
          You have unsaved data.Are you sure you want to leave this page ?
        </Typography>{" "}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onConfirm}
        >
          Yes{" "}
        </Button>{" "}
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={onClose}
        >
          No{" "}
        </Button>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default UnsaveDiscount;
